import React, { useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import BackgroundImage from "gatsby-background-image";
import { DietitianContainerProps } from "../interface/interface";
import * as styles from "./styles.module.css";

const DietitianContainer: React.FC<DietitianContainerProps> = ({
  future,
  home,
  xponent,
  className,
  children,
}) => {
  const { mobileImage, desktopImage } = useStaticQuery(
    graphql`
      query {
        desktopImage: file(relativePath: { eq: "dietitians/RD-Desktop.png" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1024) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        mobileImage: file(
          relativePath: { eq: "dietitians/mattmary-mobile.png" }
        ) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 894) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  const sources = [
    mobileImage.childImageSharp.fluid,
    {
      ...desktopImage.childImageSharp.fluid,
      media: `(min-width: 900px)`,
    },
  ];

  return (
    <div
      className={`${
        home ? styles.container : xponent ? styles.xponentcontainer : ""
      } ${future ? styles.futurecontainer : ""}`}
    >
      <BackgroundImage
        className={`${styles.wrapper} ${!!className === true && className}`}
        fluid={sources}
      >
        {children}
      </BackgroundImage>
    </div>
  );
};

export default DietitianContainer;
